import React, { useState } from 'react'
import ModalWrapper from '../ModalWraper/ModalWrapper'
import StyledButton from '../Button/StyledButton'
import FileUpload from '../FileUpload/FileUploader'
import { Typography } from '@mui/material'
import { usePostApi } from '../../shared'
import { urls } from '../../shared/config'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { setLoader, setRefreshPage } from '../../redux/globalSlice'

export const ImportBox = ({ open, handleClose }) => {
  const dispatch = useDispatch()
  const [fileName, setFileName] = useState()
  const { postApi } = usePostApi()
  const [studentJson, setStudentJson] = useState()
  const handleFileChange = (jsonData) => {
    // setStudentJson(JSON.stringify(jsonData, null, 2))
    setStudentJson(jsonData)
  }
  const handleSubmit = () => {
    dispatch(setLoader(true))
    if (!studentJson) {
      console.error('No JSON data to submit.')
      dispatch(setLoader(false))
      return
    }

    // console.log('--------data',studentJson);

    postApi(urls.IMPORT, studentJson)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          dispatch(setLoader(false))
          dispatch(setRefreshPage(true))
          handleClose()
          toast.success('Students Imported Successfully!')
        } else {
          console.error('Error:', response)
          if (response.message) {
            toast.error(response.message)
          } else {
            toast.error(response.error.message)
          }
          // toast.error(response.error.message)
          dispatch(setLoader(false))
        }
      })
      .catch((error) => {
        console.error('Error:', error)
        toast.error(error)
        dispatch(setLoader(false))
      })
  }

  return (
    <ModalWrapper open={open} handleClose={handleClose} title={'Import File'} width={'280px'}>
      <FileUpload setFileName={setFileName} label={'Upload File'} onFileChange={handleFileChange} />
      <Typography mt={-2} className="field-label">
        {fileName && fileName}
      </Typography>
      <StyledButton onClick={handleSubmit}>Submit</StyledButton>
    </ModalWrapper>
  )
}

export const ConfirmDelte = ({ open, handleDelete, handleBack,refetch }) => {
  return (
    <ModalWrapper
      open={open}
      handleClose={handleBack}
      title={'Are you sure?'}
      confirmDelete
      width={'300px'}
    >
      <div className="in-a-row" style={{ justifyContent: 'flex-end' }}>
        <StyledButton width={'50%'} onClick={handleDelete}>
          YES
        </StyledButton>
        <Typography className="back-btn" width={'50%'} onClick={handleBack}>
          NO
        </Typography>
      </div>
    </ModalWrapper>
  )
}
